<template>
  <RouterView />

  <div
    v-if="isLoading"
    class="fixed inset-0 flex flex-col justify-center items-center z-[9999] backdrop-blur-[3px]"
  >
    <div class="bg-black/20 p-5 rounded-lg flex flex-col items-center shadow">
      <div
        class="border-4 border-white border-t-4 border-t-blue-500 rounded-full w-12 h-12 animate-spin"
      ></div>
      <p class="mt-4 text-black">در حال بارگذاری...</p>
    </div>
  </div>

  <div
    v-if="toasts.length"
    class="fixed p-5 bottom-0 left-0 flex flex-col-reverse items-end space-y-1 space-y-reverse z-[10000] pointer-events-none"
  >
    <ToastNotification
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      :duration="toast.duration"
      @destroy="removeToast(toast.id)"
    />
  </div>

  <div v-if="deferredPrompt" class="fixed bottom-3 left-3 z-[10001]">
    <div
      class="bg-gray-50 rounded-lg shadow-md p-4 border border-gray-200 w-64"
    >
      <div class="relative">
        <img src="@/assets/pwa.png" alt="pwa" class="h-8 mx-auto mb-2" />
        <p class="block mb-1 text-gray-900 leading-tight text-sm">
          برای راحتی و بازدید مجدد از سایت ما، یک میانبر ایجاد نمایید
        </p>
        <div class="flex flex-wrap w-full">
          <button
            class="rounded-r justify-center px-2 py-1 bg-green-500 text-white flex font-bold w-2/3 hover:bg-green-700 hover:text-white duration-150 transition-all"
            @click="install"
          >
            نصب
          </button>
          <button
            class="rounded-l justify-center px-2 py-1 bg-red-500 text-white flex font-bold w-1/3 hover:bg-red-700 hover:text-white duration-150 transition-all"
            @click="dismiss"
          >
            انصراف
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const deferredPrompt = ref(null);

const beforeInstallPromptHandler = (e) => {
  e.preventDefault();
  deferredPrompt.value = e;
};

const appInstalledHandler = () => {
  deferredPrompt.value = null;
};

// افزودن event listeners هنگام mount شدن کامپوننت
onMounted(() => {
  window.addEventListener("beforeinstallprompt", beforeInstallPromptHandler);
  window.addEventListener("appinstalled", appInstalledHandler);
});

// حذف event listeners هنگام unmount شدن کامپوننت برای جلوگیری از memory leaks
onUnmounted(() => {
  window.removeEventListener("beforeinstallprompt", beforeInstallPromptHandler);
  window.removeEventListener("appinstalled", appInstalledHandler);
});

async function dismiss() {
  deferredPrompt.value = null;
}

async function install() {
  if (deferredPrompt.value) {
    deferredPrompt.value.prompt();
  }
}

// ایمپورت isLoading از فایل وضعیت سراسری
import { isLoading } from "@/composables/loadingState";

import { useToast } from "@/composables/useToast"; // ایمپورت useToast
import ToastNotification from "@/components/ToastNotification.vue"; // ایمپورت کامپوننت Toast

const { toasts, removeToast } = useToast(); // استفاده از کامپوزابل Toast
</script>
